// extracted by mini-css-extract-plugin
export default {"page":"Admin_page__hNrOr","adminHolder":"Admin_adminHolder__02Hjk","loginDetails":"Admin_loginDetails__7r48E","loginHolder":"Admin_loginHolder__68O9z"};